import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import BlockIcon from '@material-ui/icons/Block';
import DialogFooter from './DialogFooter';

interface NoServiceProps {
    isOpen:boolean,
}

const NoService:React.FC<NoServiceProps> = (props)=> {
    //const classes = useStyles();
    if( !props.isOpen ){
        return (null);
    }

    const close = ()=>{

    }

	return (
  		<Dialog
	        open={props.isOpen}
    	    onClose={close}
	        aria-labelledby="alert-dialog-title"
    	    aria-describedby="alert-dialog-description"
      	>
            <DialogTitle id="alert-dialog-title" className="dialogTitle"><BlockIcon style={{verticalAlign:"middle",marginRight:"0.25em"}}/>休止中</DialogTitle>
			<DialogContent>
				<DialogContentText>
                    メンテナンスのためサービスを一時休止しています。<br/>
                    最新情報は<a href="https://twitter.com/liveguide_ri" className="link">ツイッター（ハイシン！と共通）</a>をご確認ください。<br/>
				</DialogContentText>
				<DialogFooter/>
			</DialogContent>
		</Dialog>
    );
}

export default NoService;